import React from 'react';
import { Message, Button, List } from 'semantic-ui-react';
var defaultProps = {
  tertiaryMessages: [],
  actionName: null,
  actionCallback: null
};
var CheckoutMessage = function CheckoutMessage(_ref) {
  var type = _ref.type,
    primaryMessage = _ref.primaryMessage,
    secondaryMessage = _ref.secondaryMessage,
    _ref$tertiaryMessages = _ref.tertiaryMessages,
    tertiaryMessages = _ref$tertiaryMessages === void 0 ? [] : _ref$tertiaryMessages,
    actionName = _ref.actionName,
    actionCallback = _ref.actionCallback;
  return /*#__PURE__*/React.createElement(Message, {
    positive: type === 'positive',
    negative: type === 'negative'
  }, /*#__PURE__*/React.createElement(Message.Header, null, primaryMessage), /*#__PURE__*/React.createElement("p", null, secondaryMessage), !!(tertiaryMessages && tertiaryMessages.length) && /*#__PURE__*/React.createElement(List, {
    bulleted: true
  }, tertiaryMessages.map(function (msg) {
    return /*#__PURE__*/React.createElement(List.Item, null, msg);
  })), actionName && actionCallback && /*#__PURE__*/React.createElement(Button, {
    onClick: actionCallback,
    color: "red"
  }, actionName));
};
CheckoutMessage.defaultProps = defaultProps;
export default CheckoutMessage;